module.exports = __webpack_public_path__ + "static/media/satish_sir.e96598a1.jpg";